import React from 'react';
import "../news_page/news_page.css";
import infoIcon from "../../parm_assets/tree_icons.png";
import treeIncident from "../../parm_assets/tree_incident.jpg";

const NewsPageParm = () => {

    const posts = [
    {
      id: 1,
      title: "TREE FAILURE INCIDENT",
      author: "admin",
      date: " May 8, 2024",
      comments: "05",
      image: "https://ik.imagekit.io/axiomhives/parm_assets/tree_incident.jpg?updatedAt=1769929450456",
      excerpt: "Kuala Lumpur, Malaysia – Persatuan Arborist Malaysia (PArM) extends its condolences to the victims affected by the fallen tree incident that occurred yesterday, May 7, 2024, near Jalan Sultan Ismail, Kuala Lumpur. Our thoughts are with those impacted...",
      more: "/newsDetailPage",
    },
    {
      id: 2,
      title: "2024 ASIA PACIFIC TREE CLIMBING CHAMPIONSHIP",
      author: "admin",
      date: "2024",
      comments: "05",
      image: "https://ik.imagekit.io/axiomhives/parm_assets/tree_climb.jpeg?updatedAt=1769929451010",
      excerpt: "TREE CLIMBING CHAMPIONSHIP Press Release: The Asia-Pacific Tree Climbing Championship 2024 will take place in Kuantan, Pahang."
    }
  ];

  return (
    <div className="page-container">
      <section className="about-hero-section">
        <div className="about-hero-content">
          <h1 className="about-page-title">News</h1>
          <nav className="breadcrumb">
            <span className="breadcrumb-item">Home</span>
            <span className="breadcrumb-separator"> &gt; </span>
            <span className="breadcrumb-item active">News</span>
          </nav>
        </div>
      </section>

      <div className="blog-container">
      {/* Main Content */}
      <main className="main-content">
        {posts.map(post => (
          <article key={post.id} className="post-card">
            <div className="post-image">
              <img src={post.image} />
            </div>
            <div className="post-meta">
              <span>👤 By {post.author}</span>
              <span>📅 {post.date}</span>
              {/* <span>💬 Comments ({post.comments})</span> */}
            </div>
            <h2 className="post-title">{post.title}</h2>
            <p className="post-excerpt">{post.excerpt}</p>
            <a href={post.more} className="explore-btn-new-page">
            <button className="read-more-news">Read More →</button>
            </a>
          </article>
        ))}
      </main>

      {/* Sidebar */}
      <aside className="sidebar">
        {/* Search */}
        {/* <section className="sidebar-widget">
          <h3>Search Here</h3>
          <div className="search-box">
            <input type="text" placeholder="Search..." />
            <button>🔍</button>
          </div>
        </section> */}

        {/* Popular Posts */}
        {/* <section className="sidebar-widget">
          <h3>Popular Post</h3>
          {[1, 2, 3].map(i => (
            <div key={i} className="popular-post-item">
              <img src="https://via.placeholder.com/60" alt="thumb" />
              <div className="popular-post-info">
                <span>📅 Oct 19, 2025</span>
                <h4>Adventure Awaits Around Every Corner</h4>
              </div>
            </div>
          ))}
        </section> */}

        {/* Categories */}
        {/* <section className="sidebar-widget">
          <h3>Category</h3>
          <ul className="category-list">
            <li>Flight Booking</li>
            <li>Vacation Packages</li>
            <li>Car Rental Services</li>
            <li>Adventure Travel Planning</li>
          </ul>
        </section> */}

        {/* Tags */}
        {/* <section className="sidebar-widget">
          <h3>Popular Tags</h3>
          <div className="tags-container">
            {['Travel Planning', 'Safety Guides', 'Spa Retreats', 'Wine Tours', 'Solo Travel'].map(tag => (
              <span key={tag} className="tag-pill">{tag}</span>
            ))}
          </div>
        </section> */}
      </aside>
    </div>

 
    </div>
  );
};

export default NewsPageParm;